module.exports = __webpack_public_path__ + "img/icon-73.b0e75e5b.png";